var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvprofilehover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 473.62,
    height: 418.13,
    viewBox: "0 0 473.62 418.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.81,0C106.02,0,0,106.02,0,236.81c0,84.74,66.33,160.12,83.53,178.93l.11-.05c-.01-.67-.03-1.34-.03-2.02,0-75.85,68.41-137.33,152.8-137.33s152.8,61.48,152.8,137.33c0,1.49-.04,2.98-.1,4.46,51.66-43.44,84.5-108.54,84.5-181.32C473.62,106.02,367.6,0,236.81,0ZM236.81,259.9c-48.77,0-88.3-39.53-88.3-88.3s39.53-88.3,88.3-88.3,88.3,39.53,88.3,88.3-39.53,88.3-88.3,88.3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvprofilehover);
export default __webpack_public_path__ + "static/media/godtvprofilehover.26fedb763fbf5f1e9a84952e8cf068a9.svg";
export { ForwardRef as ReactComponent };